<app-header>
  <app-contract-page-nav headerLeft current="buy" [lastUpdate]="lastUpdate" [refreshing]="refreshing"
    [refreshTick]="refreshTick" (refresh)="loadContracts()"></app-contract-page-nav>

  <button mat-icon-button (click)="drawer.toggle()" [matTooltip]="drawer.opened ? 'Hide bot accounts' : 'Show bot accounts'">
    <mat-icon>{{ drawer.opened ? 'menu_open' : 'menu' }}</mat-icon>
  </button>

  @if (isAdmin) {
  <app-contract-balance variant="compact"></app-contract-balance>
  }

  @if (isAdmin) {
  <button mat-icon-button [matMenuTriggerFor]="viewMenu" matTooltip="View options">
    <mat-icon>tune</mat-icon>
  </button>
  <mat-menu #viewMenu="matMenu">
    <button mat-menu-item (click)="setViewMode('admin')">
      <mat-icon>{{ viewMode === 'admin' ? 'radio_button_checked' : 'radio_button_unchecked' }}</mat-icon>
      <span>All contracts</span>
    </button>
    <button mat-menu-item (click)="setViewMode('normal')">
      <mat-icon>{{ viewMode === 'normal' ? 'radio_button_checked' : 'radio_button_unchecked' }}</mat-icon>
      <span>My contracts only</span>
    </button>
  </mat-menu>
  }

  @if (isAdmin) {
  @let auto = (autoBuy$ | async);
  <button mat-stroked-button class="auto-buy-btn" [class.on]="auto?.is_active" [class.off]="auto && !auto.is_active"
    (click)="openAutoBuyDialog()"
    [matTooltip]="auto?.is_active ? 'Stock fleet is buying. Click to configure.' : 'Stock fleet is not buying. Click to configure.'">
    <span class="dot"></span>
    @if (auto?.is_active) {
    <span class="btn-label">Auto-buy on · </span>{{ auto!.active_leases }}/{{ auto!.desired_stocks }}
    } @else {
    <span class="btn-label">Auto-buy </span>off
    }
  </button>
  <button mat-stroked-button class="compact-btn" (click)="openTupleReportsDialog()"
    matTooltip="Tuples suppliers refused to buy" matTooltipPosition="below">
    <mat-icon>report</mat-icon>
    <span class="btn-label">Tuple reports</span>
  </button>
  }

  @if (canEdit) {
  <button mat-flat-button class="compact-btn" (click)="openCreateContractDialog()" matTooltip="New buy contract"
    matTooltipPosition="below">
    <mat-icon>add</mat-icon>
    <span class="btn-label">New Buy Contract</span>
  </button>
  }
</app-header>

<mat-drawer-container class="main-container" autosize>
  <mat-drawer #drawer class="sidenav-left" [mode]="isMobile ? 'over' : 'side'" position="start">
    <app-account-list [type]="'stock'"></app-account-list>
  </mat-drawer>

  <div class="main-content">
    <main class="page list-compact">
      @if (stats) {
      <div class="status-chips" role="group" aria-label="Filter by status">
        <button type="button" class="status-chip status-all" [class.active]="!filterStatus"
          [attr.aria-pressed]="!filterStatus" (click)="setStatusFilter('')">
          All<b>{{ stats.total_contracts }}</b>
        </button>
        @for (s of statusOptions; track s) {
        @if (stats.status_counts[s] || filterStatus === s) {
        <button type="button" class="status-chip" [ngClass]="getStatusClass(s)" [class.active]="filterStatus === s"
          [attr.aria-pressed]="filterStatus === s" (click)="setStatusFilter(s)">
          {{ s }}<b>{{ stats.status_counts[s] ?? 0 }}</b>
        </button>
        }
        }
      </div>
      }

      <div class="list-toolbar">
        <mat-form-field appearance="outline" subscriptSizing="dynamic" class="field-wide field-search">
          <mat-label>Search</mat-label>
          <mat-icon matPrefix>search</mat-icon>
          <input matInput [(ngModel)]="filterSearch" (ngModelChange)="onSearchChange()" placeholder="Name, note or buyer" />
        </mat-form-field>

        <button mat-stroked-button class="filter-toggle" [class.has-filters]="hasExtraFilters"
          (click)="filtersOpen = !filtersOpen" [attr.aria-expanded]="filtersOpen">
          <mat-icon>{{ filtersOpen ? 'expand_less' : 'tune' }}</mat-icon>
          Filters
        </button>

        <div class="filter-extra" [class.open]="filtersOpen">
          <mat-button-toggle-group [(ngModel)]="filterArchived" (ngModelChange)="onFilterChange()" aria-label="Archived">
            <mat-button-toggle value="false">Active</mat-button-toggle>
            <mat-button-toggle value="">All</mat-button-toggle>
            <mat-button-toggle value="true">Archived</mat-button-toggle>
          </mat-button-toggle-group>

          @if (useAdminView) {
          <mat-form-field appearance="outline" subscriptSizing="dynamic">
            <mat-label>Owner role</mat-label>
            <mat-select [(ngModel)]="filterOwnerRole" (ngModelChange)="onFilterChange()">
              <mat-option value="">All</mat-option>
              @for (r of roleOptions; track r) {
              <mat-option [value]="r">{{ r }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
          }

          <mat-form-field appearance="outline" subscriptSizing="dynamic" class="field-wide">
            <mat-label>Created between</mat-label>
            <mat-date-range-input [rangePicker]="rangePicker">
              <input matStartDate [(ngModel)]="filterStartDate" (ngModelChange)="onDateRangeChange()" placeholder="Start">
              <input matEndDate [(ngModel)]="filterEndDate" (ngModelChange)="onDateRangeChange()" placeholder="End">
            </mat-date-range-input>
            <mat-datepicker-toggle matSuffix [for]="rangePicker"></mat-datepicker-toggle>
            <mat-date-range-picker #rangePicker></mat-date-range-picker>
          </mat-form-field>

          @if (hasActiveFilters) {
          <button mat-button (click)="clearFilters()">
            <mat-icon>filter_alt_off</mat-icon>
            Clear filters
          </button>
          }
        </div>

        <span class="spacer"></span>

        @if (isAdmin && !useAdminView) {
        <button type="button" class="pill status-stopped view-pill" (click)="setViewMode('admin')"
          matTooltip="Showing only your own contracts. Click to show all.">
          My contracts only <mat-icon>close</mat-icon>
        </button>
        }

        <button mat-stroked-button class="compact-btn" (click)="archiveAllInactive()" [disabled]="!canEdit || archivingInactive"
          matTooltip="Archive every non-Active contract (Done, Canceled, Expired, Failed) matching the search/date filters">
          <mat-icon>archive</mat-icon>
          <span class="btn-label">Archive inactive</span>
        </button>
      </div>

      @if (searchError || dateRangeError) {
      <div class="filter-errors">
        @if (searchError) {
        <div class="filter-error"><mat-icon>error_outline</mat-icon>{{ searchError }}</div>
        }
        @if (dateRangeError) {
        <div class="filter-error"><mat-icon>error_outline</mat-icon>{{ dateRangeError }}</div>
        }
      </div>
      }

      @if (stats) {
      <div class="summary-strip">
        <div class="metric">
          <span class="metric-label">Target</span>
          <span class="metric-value">{{ formatCoins(stats.total_target) }}</span>
        </div>
        <div class="metric">
          <span class="metric-label">Sent</span>
          <span class="metric-value">{{ formatCoins(stats.total_sent) }}</span>
        </div>
        <div class="metric">
          <span class="metric-label">Remaining (active)</span>
          <span class="metric-value">{{ formatCoins(stats.left_target.total) }}</span>
        </div>
        <div class="metric">
          <span class="metric-label">Total fee</span>
          <span class="metric-value">{{ formatToman(stats.total_fee) }}</span>
        </div>
        <div class="metric">
          <span class="metric-label">Avg fee rate</span>
          <span class="metric-value">{{ formatToman(stats.avg_fee) }}</span>
        </div>
        <div class="metric metric-progress" matTooltip="Sent coins vs. total target, across all matched contracts">
          <span class="metric-label">{{ statsPercentReached }}% of target</span>
          <mat-progress-bar mode="determinate" [value]="statsPercentReached"></mat-progress-bar>
        </div>
      </div>
      }

      @if (canEdit && selectedIds.size > 0) {
      <div class="bulk-bar">
        <mat-icon>checklist</mat-icon>
        <span><b>{{ selectedIds.size }}</b> selected</span>
        <span class="spacer"></span>
        <button mat-stroked-button (click)="bulkSetArchived(true)">
          <mat-icon>archive</mat-icon>
          Archive
        </button>
        <button mat-stroked-button (click)="bulkSetArchived(false)">
          <mat-icon>unarchive</mat-icon>
          Unarchive
        </button>
        <button mat-button (click)="selectedIds.clear()">Clear</button>
      </div>
      }

      <div class="table-card">
      @if (loading) {
      <div class="table-state">
        <mat-progress-spinner diameter="32" mode="indeterminate"></mat-progress-spinner>
        Loading buy contracts…
      </div>
      } @else {
      <div class="table-scroll">
        <table mat-table [dataSource]="contracts" [trackBy]="trackByContractId">

          <ng-container matColumnDef="select">
            <th mat-header-cell *matHeaderCellDef>
              <mat-checkbox [checked]="allSelected" [indeterminate]="someSelected" (change)="toggleSelectAll()">
              </mat-checkbox>
            </th>
            <td mat-cell *matCellDef="let c">
              <mat-checkbox [checked]="selectedIds.has(c.id)" (change)="toggleSelect(c.id)">
              </mat-checkbox>
            </td>
          </ng-container>

          <ng-container matColumnDef="id">
            <th mat-header-cell *matHeaderCellDef>Name</th>
            <td mat-cell *matCellDef="let c">
              <a class="contract-name-btn" (click)="openContractInfoDialog(c)">
                {{ c.name || shortId(c.id) }}
              </a>
            </td>
          </ng-container>

          <ng-container matColumnDef="owner">
            <th mat-header-cell *matHeaderCellDef>Buyer</th>
            <td mat-cell *matCellDef="let c">
              <div class="owner-cell owner-cell--clickable" matTooltip="View buyer info"
                (click)="openSupplierInfoDialog(c)">
                <span class="owner-username">{{ c.buyer_username }}</span>
                @if (c.buyer_roles?.length) {
                <span class="owner-roles" [matTooltip]="c.buyer_roles.join(', ')">{{ c.buyer_roles.join(', ') }}</span>
                }
              </div>
            </td>
          </ng-container>

          <ng-container matColumnDef="note">
            <th mat-header-cell *matHeaderCellDef>Note</th>
            <td mat-cell *matCellDef="let c" class="note-cell">
              @if (c.note) {
              <span class="note-text" [matTooltip]="c.note" matTooltipShowDelay="300">{{ c.note }}</span>
              } @else {
              <span class="empty-value">—</span>
              }
            </td>
          </ng-container>

          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef>
              Status
              <div class="sub-header">process / payment</div>
            </th>
            <td mat-cell *matCellDef="let c">
              <div class="status-container">
                <span [class]="'status-badge ' + getStatusClass(c.status)"
                  [matTooltip]="c.failed_reason ? 'Fail reason: ' + c.failed_reason : undefined">{{ c.status }}</span>
                <span [class]="'payment-badge ' + getPaymentClass(c.payment_status)" [matTooltip]="c.payment_status">
                  <mat-icon class="payment-icon">{{ getPaymentIcon(c.payment_status) }}</mat-icon>
                </span>
              </div>
            </td>
          </ng-container>

          <ng-container matColumnDef="progress">
            <th mat-header-cell *matHeaderCellDef>
              Progress
              <div class="sub-header">sent/received/target</div>
            </th>
            <td mat-cell *matCellDef="let c">
              <div class="progress-cell" [matTooltip]="progressPercent(c) + '%'">
                <span class="progress-text">{{ formatCoins(c.sent_coins) }} / {{ formatCoins(c.received_coins) }} / {{
                  formatCoins(c.target_coins) }} ({{ c.target_type }})</span>
                <div class="progress-bar">
                  <div class="progress-bar-fill" [style.width.%]="progressPercent(c)"></div>
                </div>
              </div>
            </td>
          </ng-container>

          <ng-container matColumnDef="billing">
            <th mat-header-cell *matHeaderCellDef>
              Billing
              <div class="sub-header">total (fee)</div>
            </th>
            <td mat-cell *matCellDef="let c">
              <div class="billing-cell">
                <div class="billing-total">{{ formatToman(c.fee_amount) }}</div>
                <div class="billing-fee">({{ formatToman(c.fee) }})</div>
              </div>
            </td>
          </ng-container>

          <ng-container matColumnDef="allocations_summary">
            <th mat-header-cell *matHeaderCellDef>
              Allocations
              <div class="sub-header">Total / Locked / Bought / Released / Expired</div>
            </th>
            <td mat-cell *matCellDef="let c">
              @if (c.allocations) {
              <div class="counter-row">
                <span class="counter" [class.is-zero]="!c.allocations.total" matTooltip="Total">{{ c.allocations.total }}</span>
                <span class="counter counter--locked" [class.is-zero]="!c.allocations.locked" matTooltip="Locked">{{ c.allocations.locked }}</span>
                <span class="counter counter--bought" [class.is-zero]="!c.allocations.bought" matTooltip="Bought">{{ c.allocations.bought }}</span>
                <span class="counter counter--released" [class.is-zero]="!c.allocations.released" matTooltip="Released">{{ c.allocations.released }}</span>
                <span class="counter counter--expired" [class.is-zero]="!c.allocations.expired" matTooltip="Expired">{{ c.allocations.expired }}</span>
              </div>
              } @else {
              <span class="empty-value">—</span>
              }
            </td>
          </ng-container>

          <ng-container matColumnDef="timing">
            <th mat-header-cell *matHeaderCellDef>
              Timing
              <div class="sub-header">Start / Finish</div>
            </th>
            <td mat-cell *matCellDef="let c">
              <div class="time">
                {{ formatDateAndTime(c.started_at) }}
              </div>
              <div class="time">
                @if (c.finished_at) {
                {{ formatDateAndTime(c.finished_at) }}
                } @else {
                <span class="empty-value">—</span>
                }
              </div>
            </td>
          </ng-container>

          <ng-container matColumnDef="action">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let c">
              <button mat-icon-button [matMenuTriggerFor]="menu">
                <mat-icon>more_vert</mat-icon>
              </button>

              <mat-menu #menu="matMenu">
                @if (canEdit && isActive(c)) {
                <button mat-menu-item (click)="openPatchDialog(c)">
                  <mat-icon>edit</mat-icon>
                  <span>Edit</span>
                </button>
                }

                <button mat-menu-item (click)="viewAllocations(c)">
                  <mat-icon>style</mat-icon>
                  <span>View Allocations</span>
                </button>

                <button mat-menu-item (click)="shareLink(c)">
                  <mat-icon>share</mat-icon>
                  <span>Share Link</span>
                </button>

                @if (isAdmin && canEdit) {
                <button mat-menu-item (click)="openBillingDialog(c)">
                  <mat-icon>payments</mat-icon>
                  <span>Edit Billing</span>
                </button>
                }

                @if (canEdit && isActive(c)) {
                <button mat-menu-item (click)="cancel(c)">
                  <mat-icon>cancel</mat-icon>
                  <span>Cancel</span>
                </button>
                } @else if (canEdit) {
                <button mat-menu-item (click)="resume(c)">
                  <mat-icon>play_arrow</mat-icon>
                  <span>Resume</span>
                </button>
                }

                @if (canEdit && isDone(c)) {
                <button mat-menu-item (click)="releaseLocks(c)">
                  <mat-icon>lock_open</mat-icon>
                  <span>Release Locks</span>
                </button>
                }

                @if (canEdit) {
                @if (!c.archived) {
                <button mat-menu-item (click)="setArchived(c, true)">
                  <mat-icon>archive</mat-icon>
                  <span>Archive</span>
                </button>
                } @else {
                <button mat-menu-item (click)="setArchived(c, false)">
                  <mat-icon>unarchive</mat-icon>
                  <span>Unarchive</span>
                </button>
                }
                }
              </mat-menu>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
      </div>

      <div class="contract-cards">
        @for (c of contracts; track c.id) {
        <div class="contract-card">
          <div class="card-top">
            <div class="card-select-name">
              <mat-checkbox [checked]="selectedIds.has(c.id)" (change)="toggleSelect(c.id)"></mat-checkbox>
              <a class="contract-name-btn" (click)="openContractInfoDialog(c)">{{ c.name || shortId(c.id) }}</a>
            </div>

            <button mat-icon-button [matMenuTriggerFor]="cardMenu">
              <mat-icon>more_vert</mat-icon>
            </button>

            <mat-menu #cardMenu="matMenu">
              @if (canEdit && isActive(c)) {
              <button mat-menu-item (click)="openPatchDialog(c)">
                <mat-icon>edit</mat-icon>
                <span>Edit</span>
              </button>
              }

              <button mat-menu-item (click)="viewAllocations(c)">
                <mat-icon>style</mat-icon>
                <span>View Allocations</span>
              </button>

              <button mat-menu-item (click)="shareLink(c)">
                <mat-icon>share</mat-icon>
                <span>Share Link</span>
              </button>

              @if (isAdmin && canEdit) {
              <button mat-menu-item (click)="openBillingDialog(c)">
                <mat-icon>payments</mat-icon>
                <span>Edit Billing</span>
              </button>
              }

              @if (canEdit && isActive(c)) {
              <button mat-menu-item (click)="cancel(c)">
                <mat-icon>cancel</mat-icon>
                <span>Cancel</span>
              </button>
              } @else if (canEdit) {
              <button mat-menu-item (click)="resume(c)">
                <mat-icon>play_arrow</mat-icon>
                <span>Resume</span>
              </button>
              }

              @if (canEdit && isDone(c)) {
              <button mat-menu-item (click)="releaseLocks(c)">
                <mat-icon>lock_open</mat-icon>
                <span>Release Locks</span>
              </button>
              }

              @if (canEdit) {
              @if (!c.archived) {
              <button mat-menu-item (click)="setArchived(c, true)">
                <mat-icon>archive</mat-icon>
                <span>Archive</span>
              </button>
              } @else {
              <button mat-menu-item (click)="setArchived(c, false)">
                <mat-icon>unarchive</mat-icon>
                <span>Unarchive</span>
              </button>
              }
              }
            </mat-menu>
          </div>

          @if (useAdminView) {
          <div class="owner-cell owner-cell--clickable" (click)="openSupplierInfoDialog(c)">
            <span class="owner-username">{{ c.buyer_username }}</span>
            @if (c.buyer_roles?.length) {
            <span class="owner-roles">{{ c.buyer_roles ? c.buyer_roles.join(', ') : 'no role' }}</span>
            }
          </div>
          }

          <div class="card-badges">
            <span [class]="'status-badge ' + getStatusClass(c.status)"
              [matTooltip]="c.failed_reason ? 'Fail reason: ' + c.failed_reason : undefined">{{ c.status }}</span>
            <span [class]="'payment-badge ' + getPaymentClass(c.payment_status)" [matTooltip]="c.payment_status">
              <mat-icon class="payment-icon">{{ getPaymentIcon(c.payment_status) }}</mat-icon>
            </span>
          </div>

          @if (c.note) {
          <div class="card-note">{{ c.note }}</div>
          }

          <div class="progress-cell" [matTooltip]="progressPercent(c) + '%'">
            <span class="progress-text">{{ formatCoins(progressCoins(c)) }} / {{ formatCoins(c.target_coins) }}</span>
            <div class="progress-bar">
              <div class="progress-bar-fill" [style.width.%]="progressPercent(c)"></div>
            </div>
          </div>

          <div class="card-meta">
            <div>
              <span class="meta-label">Target Type</span>
              {{ c.target_type }}
            </div>
            <div>
              <span class="meta-label">Fee</span>
              {{ formatToman(c.fee) }}
            </div>
            <div>
              <span class="meta-label">Total Price</span>
              {{ formatToman(c.fee_amount) }}
            </div>
            <div>
              <span class="meta-label">Started</span>
              {{ formatDateAndTime(c.started_at) }}
            </div>
            <div>
              <span class="meta-label">Finished</span>
              @if (c.finished_at) {
              {{ formatDateAndTime(c.finished_at) }}
              } @else {
              <span class="empty-value">—</span>
              }
            </div>
          </div>

          @if (c.allocations) {
          <div class="counter-row">
            <span class="counter" [class.is-zero]="!c.allocations.total" matTooltip="Total">{{ c.allocations.total }}</span>
            <span class="counter counter--locked" [class.is-zero]="!c.allocations.locked" matTooltip="Locked">{{ c.allocations.locked }}</span>
            <span class="counter counter--bought" [class.is-zero]="!c.allocations.bought" matTooltip="Bought">{{ c.allocations.bought }}</span>
            <span class="counter counter--released" [class.is-zero]="!c.allocations.released" matTooltip="Released">{{ c.allocations.released }}</span>
            <span class="counter counter--expired" [class.is-zero]="!c.allocations.expired" matTooltip="Expired">{{ c.allocations.expired }}</span>
          </div>
          }
        </div>
        }
      </div>

      @if (contracts.length === 0) {
      <div class="table-state">
        <mat-icon>inbox</mat-icon>
        No buy contracts match these filters.
      </div>
      }

      <mat-paginator [length]="total" [pageIndex]="pageIndex" [pageSize]="pageSize"
        [pageSizeOptions]="[20, 50, 100]" (page)="onPage($event)">
      </mat-paginator>
      }
      </div>
    </main>
  </div>
</mat-drawer-container>